import styled from "styled-components";

export const HeaderInformation = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 90px;
  width: 65%;
`;

export const ContainerRow = styled.div`
  display: flex;
`;

export const ButtonNotification = styled.button`
  margin-left: 10px;
  height: 50px;
  width: 50px;
  margin-top: 5px;
  border-radius: 8px;
  background: #e7f3fd;
  cursor: pointer;
  border: none;
`;
